var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery mx-auto",style:(_vm.computedStyle)},[_vm._l((_vm.currentSlice),function(ref,i){
var id = ref.id;
var data = ref.data;
return _c('div',{key:id,ref:"slides",refInFor:true,staticClass:"slide",on:{"click":_vm.changeSlide}},[_c('ResponsiveImage',{staticClass:"image",attrs:{"data":data,"role":i === 0 ? null : 'presentation'}})],1)}),_vm._v(" "),_c('div',{staticClass:"status"},_vm._l((_vm.slides),function(_,i){return _c('div',{key:i,ref:"statusItem",refInFor:true,staticClass:"status_item",class:{
        'previous': i < _vm.currentIndex,
        'active': i === _vm.currentIndex
      }})}),0)],2)}
var staticRenderFns = []

export { render, staticRenderFns }